import {
  Box,
  Container,
  Typography,
  Stack,
  Grid,
} from "@mui/material";

import { CheckCircle as CheckCircleIcon, Info as InfoIcon } from "@mui/icons-material";
import SectionHeader from "../components/SectionHeader";

interface WhatItMeansProps {
  bgcolor?: string;
}

const standardFeatures = [
  "Guest-ready appearance",
  "Hygiene and consistency",
  "Fast, reliable turnovers",
  "Not deep restoration",
];

export default function WhatItMeans({ bgcolor = "background.paper" }: WhatItMeansProps) {
  return (
    <Box sx={{ bgcolor, width: "100%" }}>
      <Container 
        component="section" 
        maxWidth="lg" 
        sx={{ 
          maxWidth: "1000px !important", 
          py: { xs: 4, md: 7 }, 
          px: { xs: 2, sm: 3, md: 4 } 
        }}
      >
        <SectionHeader
          title='AirBnB Turnover Cleaning in Toronto'
          subtitle="Additional services available upon request."
        />

        <Grid container spacing={{ xs: 3, md: 4 }} alignItems="center" justifyContent="center">
          {/* Left side - Description */}
          <Grid item xs={12} md={5}>
            <Typography 
              variant="body1" 
              sx={{ 
                lineHeight: 1.7, 
                color: "text.secondary",
                fontSize: { xs: "0.95rem", md: "1.05rem" },
                textAlign: "justify",
                mx: { xs: 1, md: 0 }
              }}
            >
              <Box component="span" sx={{ fontWeight: "bold" }}>AirBnB cleaning</Box> is designed for fast, reliable turnovers between short-term rental guests.
              It focuses on guest-ready appearance, hygiene, and consistency, allowing your unit to be
              prepared efficiently for the next check-in.
            </Typography>
          </Grid>

          {/* Right side - Features List */}
          <Grid item xs={12} md="auto">
            <Stack spacing={2} mx={{ xs: 5, md: 0 }} >
              {standardFeatures.map((feature, index) => (
                <Stack direction="row" spacing={1.5} alignItems="flex-start" key={index}>
                  <CheckCircleIcon 
                    sx={{ 
                      color: "#4CAF50", 
                      mt: 0.2,
                      fontSize: { xs: 18, md: 20 }, 
                      flexShrink: 0 
                    }} 
                  />
                  <Typography 
                    variant="body1" 
                    sx={{ 
                      lineHeight: 1.6, 
                      color: "#333", 
                      fontWeight: 500,
                      fontSize: { xs: "0.95rem", md: "1rem" }
                    }}
                  >
                    {feature}
                  </Typography>
                </Stack>
              ))}
            </Stack>
          </Grid>
        </Grid>

        <Box
          sx={{
            mt: { xs: 3, md: 4 },
            pt: { xs: 3, md: 4 },
            borderTop: "1px solid",
            borderColor: "divider"
          }}
        >
          <Stack 
            direction="row" 
            spacing={{ xs: 1.5, md: 1.5 }}
            sx={{ 
              p: { xs: 2, md: 2.25 },
              bgcolor: "rgba(76, 175, 80, 0.05)",
            borderLeft: "3px solid #4CAF50",
            borderRadius: 1,
            alignItems: "flex-start"
          }}
        >
          <InfoIcon 
            sx={{ 
              color: "#4CAF50", 
              fontSize: { xs: 20, md: 22 }, 
              mt: 0.1, 
              flexShrink: 0 
            }} 
          />
          <Typography 
            variant="body2" 
            sx={{ 
              lineHeight: 1.6, 
              color: "#333",
              fontSize: { xs: "0.875rem", md: "0.9rem" },
              textAlign: "left"
            }}
          >
            <Box component="span" sx={{ fontWeight: 600 }}>Transparent pricing</Box> — Our turnover 
            cleaning is designed for well-maintained properties. If your unit requires deep cleaning, 
            excessive laundry, or additional tasks, we'll always discuss pricing before starting.
          </Typography>
        </Stack>
        </Box>
      </Container>
    </Box>
  );
}
